import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { StatBadges } from './components/StatBadges';
import { TransformationSection } from './components/TransformationSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ComparisonTable } from './components/ComparisonTable';
import { TestimonialsFull } from './components/TestimonialsFull';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FooterCta } from './components/FooterCta';
import { PurchasePopup } from './components/PurchasePopup';
import { initPixel } from './lib/pixel';
export function App() {
  useEffect(() => {
    // Defer analytics so the external pixel script doesn't compete with first paint
    const w = window as Window & {
      requestIdleCallback?: (cb: () => void) => number;
    };
    if (typeof w.requestIdleCallback === 'function') {
      w.requestIdleCallback(() => initPixel());
    } else {
      const t = setTimeout(() => initPixel(), 2000);
      return () => clearTimeout(t);
    }
  }, []);
  return <div className="w-full min-h-screen bg-surface-light" data-id="element-0" data-mp="3rdkisa5iorpx">
      <HeroSection data-id="element-1" data-mp="5ott78p769p" />
      <StatBadges data-id="element-2" data-mp="6817u0q2c9h" />
      <TransformationSection data-id="element-3" data-mp="4n6o4eeqtbm" />
      <TomosSection data-id="element-4" data-mp="82ovg3doih9" />
      <BonusSection data-id="element-5" data-mp="2zld0z6e9z99y" />
      <PricingSection data-id="element-6" data-mp="2zlv84y2h77wn" />
      <ComparisonTable data-id="element-7" data-mp="2zmem63p09c5e" />
      <TestimonialsFull data-id="element-8" data-mp="2zn6bwxvx8fnr" />
      <GuaranteeSection data-id="element-9" data-mp="33mf25srr5vek" />
      <FaqSection data-id="element-10" data-mp="33lx18iu5at0b" />
      <FooterCta data-id="element-11" data-mp="33n6zp94wu37h" />
      <PurchasePopup data-id="element-12" data-mp="33ori60dy9voz" />
    </div>;
}